export default __webpack_public_path__ + "static/media/groups_placeholder1.6bbc6938.png";